import { render, staticRenderFns } from "./ExtrusionsSettings.vue?vue&type=template&id=59e00364&scoped=true&"
import script from "./ExtrusionsSettings.vue?vue&type=script&lang=js&"
export * from "./ExtrusionsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExtrusionsSettings.vue?vue&type=style&index=0&id=59e00364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e00364",
  null
  
)

export default component.exports